import React from 'react';
import { Redirect, RedirectProps } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';
import { useStatusCode } from '../../hooks/useStatusCode';

type Props = RedirectProps & { statusCode?: number };

export const RedirectWithStatusCode: React.FC<Props> = ({
  statusCode = StatusCodes.MOVED_PERMANENTLY,
  ...rest
}) => {
  useStatusCode(statusCode);
  return <Redirect {...rest} />;
};
